<template>
  <div class="login-form">
    <div class="btns">
      <h3>重置密码</h3>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0"
      class="form"
    >
      <el-form-item prop="pwd">
        <el-input
          type="password"
          v-model="ruleForm.pwd"
          placeholder="请输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item prop="repwd">
        <el-input
          type="password"
          v-model="ruleForm.repwd"
          placeholder="请确认新密码"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" size="small"
          >提 交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "ForgetPassword",
  mounted() {
    this.ruleForm.mobile = this.$route.query["mobile"];
    this.ruleForm.code = this.$route.query["code"];
  },
  data() {
    let validateRepwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        pwd: "",
        repwd: "",
        mobile: "",
        code: "",
      },
      rules: {
        pwd: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 6, max: 20, message: "密码长度为6-20位", trigger: "blur" },
        ],
        repwd: [{ validator: validateRepwd, trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            mobile: this.ruleForm.mobile,
            code: this.ruleForm.code,
            newPass: this.ruleForm.pwd,
          };
          this.$http
            .post("/fireeye/public/pass/reset", qs.stringify(data))
            .then((res) => {
              console.log(res);
              let data = res.data;
              if (data.code === 1) {
                data = data.data;
                this.$router.push({ path: "/login" });
              } else {
                this.$message.error(data.msg);
              }
            });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.captcha-btn {
  float: right;
}
</style>